import styled from 'styled-components';
import { colors, fonts } from '../../../css';

export const TwoFactorAuthWrapper = styled.div`
  text-align: center;
`;

export const TwoFactorInput = styled.input`
  margin: 0 4px;
  width: 45px;
  height: 60px;
  padding-top: 0.2em;
  font-family: ${fonts.fontRegular};
  font-size: 38px;
  text-align: center;
  vertical-align: middle;
  line-height: 60px;
  color: ${colors.colorGrey02};
  border: solid 1px ${colors.colorGrey04};
  border-radius: 8px;
  outline: none;

  &.invalid {
    border-color: ${colors.colorRed};
  }
`;
